import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, List, Stack, Typography } from '@mui/material';

import ListSearch from './components/ListSearch';

interface ListWithSearchProps {
  children: React.ReactNode;
  handleSearch?: (value: string | null, searchParameter?: string) => void;
  searchParameter?: string;
  isLoading: boolean;
  isSearching: boolean;
  searchInputPlaceholder: string;
}

const ListWithSearch: React.FC<ListWithSearchProps> = ({
  children,
  handleSearch,
  searchParameter,
  isLoading,
  isSearching,
  searchInputPlaceholder,
}) => {
  const { t } = useTranslation('report');

  return (
    <>
      {handleSearch && (
        <ListSearch
          handleSearch={handleSearch}
          searchInputPlaceholder={searchInputPlaceholder}
          searchParameter={searchParameter}
        />
      )}

      {isSearching && (
        <Typography variant="h6" sx={{ mt: 4, mb: 2, position: 'relative' }}>
          {t('sidebar.searchResults')}
          {isLoading && (
            <Box sx={{ position: 'absolute', right: 0, top: 0 }}>
              <CircularProgress size={20} />
            </Box>
          )}
        </Typography>
      )}

      {!isSearching && isLoading && (
        <Stack direction="row" sx={{ justifyContent: 'center' }}>
          <CircularProgress size={20} />
        </Stack>
      )}

      {!isLoading && <List>{children}</List>}
    </>
  );
};

export default ListWithSearch;
